import React, { useEffect, useState } from 'react'
import './userProfile.scss'
import { Collapse, Flex, Tag, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Loader from '../../../../components/Loader/Loader';
import EmployeeProfileImage from '../../../employee/employee-details/employee-profile/EmployeeProfileImage';
import allAboardLogo from '../../../../assets/images/profile.jpg'
import appraisalImg from './../../../../assets/images/new-dashboard/appraisal.svg';
import UserCompanyDetails from './UserCompanyDetails';
import UserPersonalDetails from './UserPersonalDetails';
import UserEditDetailsModal from './modal/UserEditDetailsModal';
import UserEditProfileImage from './modal/UserEditProfileImage';
import { useIsMobile } from '../../../../hooks/commonHooks';
import SendMail from './modal/SendMail';
import { setApiResponseMessage, setIsError, setIsSubmitted, setIsSuccess, setSendBtnLoading } from '../../../../redux/slices/composeEmailSlice';
import { triggerNotification, useGetApiRequests } from '../../../../common/CommonExport';
import { setEmployeeDetails } from '../../../../redux/slices/employee/employeeDetailsSlice';

const { Panel } = Collapse;

interface EmployeeProfileProps {
  layoutFull: (el: string) => void;
}
export default function UserProfile({ layoutFull }: EmployeeProfileProps) {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_VIEW;
  const dispatch = useDispatch();
  const reloadData = useSelector((state: any) => state?.profileReload?.profileLoad);
  const deprovisionReload = useSelector((state: any) => state?.profileReload?.deprovisionLoad);
  const employeeDetails = useSelector((state: any) => state?.employee?.employeeDetails);
  const { isSubmitted, emailData } = useSelector((state: any) => state?.composeEmailSlice);
  const employeeResignationApi = useGetApiRequests('employeeResignation', 'POST');
  const getEmployeeDetailsApi = useGetApiRequests('getEmployeeDetails', 'GET');

  const [modalOpen, setModalOpen] = useState<any>(false);
  const [loader, setLoader] = useState(false);
  const [imageOpen, setImageOpen] = useState<boolean>(false)
  const isMobile = useIsMobile();
  const [resignModalOpen, setResignModalOpen] = useState<boolean>(false);
  useEffect(() => {
    // employeeDetails('', {}, { id })
    //   .then((res: any) => {
    //     setLoader(false)
    //     setEmployeeInformation(res?.data?.data)
    //     if (res?.data?.data?.isDeprovisionStarted === true) {
    //       dispatch(setDeprovision(true));
    //     } else {
    //       dispatch(setDeprovision(false));
    //     }
    //     dispatch(setParticularEmployeeData(res?.data?.data))
    //     setIsEmailSent(res?.data?.data?.isBasicFormSent)
    //     dispatch(setParticularEmployeeData(res?.data?.data))
    //     dispatch(setEmpId(res?.data?.data?.designation?.designationId));
    //   })
    //   .catch((err: any) => {
    //     console.error(err)
    //     setLoader(false)
    //   })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData, deprovisionReload])

  useEffect(() => {
    getEmployeeDetails();
  }, []);

  useEffect(() => {
    const submitResignation = async () => {
      if (isSubmitted) {
        const payload = {
          relevingDate: emailData?.customFields?.relievingDate,
          resignationDate: emailData?.customFields?.resignDate,
          otherReason: emailData?.customFields?.reason,
          resignationLetter: emailData?.body?.toString(),
        };
        const params: any = {
          employeeId: employeeDetails?.employeeId,
          organisationId: employeeDetails?.organisationId,
        };
        try {
          const response: any = await employeeResignationApi(payload, params);
          if (response?.status === 200) {
            dispatch(setIsSubmitted(false));
            dispatch(setSendBtnLoading(false));
            dispatch(setIsSuccess(true));
            dispatch(setApiResponseMessage(response?.data?.status?.message ?? "Successfully submitted"));
            setLoader(true);
            getEmployeeDetails();
          }
        } catch (err: any) {
          dispatch(setIsSubmitted(false));
          dispatch(setIsError(true));
          dispatch(setApiResponseMessage(err?.message));
          dispatch(setSendBtnLoading(false));
        }
      }
    };

    submitResignation();
  }, [isSubmitted]);

  const getEmployeeDetails = async () => {
    try {
      const response: any = await getEmployeeDetailsApi('', {}, { employeeId: employeeDetails?.employeeId })
      const data = await response.data
      if (data?.status === 200) {
        dispatch(setEmployeeDetails(data?.data));
        setLoader(false);
      }
      setLoader(false);
    } catch (err: any) {
      setLoader(false);
      triggerNotification('error', '', err?.response?.data?.status?.message ?? err?.message, 'topRight');
    }
  }


  const handleImageOpen = () => {
    setImageOpen(true)
  }

  const handelSendMail = () => {
    setResignModalOpen(true);
  }

  const handelCloseSendMail = () => {
    setResignModalOpen(false);
  }

  return (
    <>
      {loader && <Loader />}
      <div className="employee-details__card">


        <div className="img-data">
          <div>
            <img onClick={() => handleImageOpen()} alt='logo' src={employeeDetails?.profileUrl ? `${imageBaseUrl}${employeeDetails?.profileUrl}` : allAboardLogo} className='employee_image' />
          </div>
          {!isMobile ? <Tooltip placement="top" title={'Edit'}>
            <span className="material-symbols-outlined edit-profile" onClick={() => setModalOpen(true)}>edit</span>
          </Tooltip> : <span className="material-symbols-outlined edit-profile" onClick={() => setModalOpen(true)}>edit</span>}

          <button className="personal-card-button flex justify-center items-center" onClick={() => { layoutFull("") }} >
            <span className='material-symbols-outlined'>chevron_left</span>
          </button>

          <div className="employee-job font-rubik">
            <p className="employee-name font-rubik">{`${employeeDetails?.firstName} ${employeeDetails?.lastName}`}</p>

            <Flex gap="4px 0" className='mt-2 font-rubik'>
              <Tag color="magenta" bordered={false} className='font-rubik'>{employeeDetails?.designation?.name}</Tag>
              <Tag color="magenta" bordered={false} className='font-rubik'>{employeeDetails?.department?.name}</Tag>
            </Flex>
            <Flex gap="4px 0" className='mt-2'>

              {
                employeeDetails?.reviewStatus && <Tag color="magenta" bordered={false}>
                  {employeeDetails?.reviewStatus.toLowerCase() === 'pending' && (
                    <div className='flex items-center'>
                      <img src={appraisalImg} alt='Appraisal images' className='appraisalImg' />
                      <span>  Appraisal Pending </span>
                    </div>
                  )}
                </Tag>
              }
            </Flex>
          </div>
        </div>

        {
          employeeDetails?.status?.name !== 'Notice Period' ?
            <div className='flex justify-end'>
              <p role='none' onClick={() => handelSendMail()} className='underline mr-3 mb-2 cursor-pointer hover:text-[#D34A7C] text-[14px] text-[#595959]'>
                Resign
              </p>
            </div> : <div className='h-[30px]'></div>
        }

        <div className="employee-details__personal-main">
          <div className="employee-details__personal">
            <Collapse defaultActiveKey={['1']} bordered={false} >
              <Panel header="Company Details" key="1">
                <UserCompanyDetails />
              </Panel>
              <Panel header="Personal Details" key="2">
                <UserPersonalDetails />
              </Panel>
            </Collapse>
            {modalOpen && <UserEditDetailsModal open={modalOpen} setModalOpen={setModalOpen} />}
            {imageOpen && <UserEditProfileImage open={imageOpen} setImageOpen={setImageOpen} imageURL={employeeDetails?.profileUrl ? `${imageBaseUrl}${employeeDetails?.profileUrl}` : allAboardLogo} />}
          </div>
        </div>

        {resignModalOpen && <SendMail open={resignModalOpen} handelClose={handelCloseSendMail} />}
      </div>
    </>
  )
}

